export default "__VITE_ASSET__CgVuqZbl__"